import(/* webpackMode: "eager" */ "/vercel/path0/src/app/collection/page.style.scss");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/AppShellLayer/AppShellLayer.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/ProductListApp/ProductListApp.tsx")